const InputTimePicker = ({ formik, fieldName, onChange, time }) => (
  <div>
    <input
      type="time"
      value={time}
      className={`form-control instn fs-16 regular w-100 olnone share-popup-input fmlabel ${
        formik.errors[fieldName] && formik.touched[fieldName] && "error-field"
      } `}
      onChange={(e) => formik.setFieldValue(fieldName, e.target.value)}
    />
  </div>
);

export default InputTimePicker;
